import script from "./ContactFAB.vue?vue&type=script&setup=true&lang=js"
export * from "./ContactFAB.vue?vue&type=script&setup=true&lang=js"

import "./ContactFAB.vue?vue&type=style&index=0&id=1fadf3ab&lang=scss"

const __exports__ = script;

export default __exports__